var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrendingUpIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: 0.55
}, /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 20,
  height: 20,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#06CA3D",
  d: "m2.833 15-1.166-1.167 6.166-6.208 3.333 3.333L15.5 6.667h-2.167V5h5v5h-1.666V7.833l-5.5 5.5L7.833 10z"
})))));
export { SvgTrendingUpIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC41NSI+CjxtYXNrIGlkPSJtYXNrMF8yMDY0XzI0NzUiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMjA2NF8yNDc1KSI+CjxwYXRoIGQ9Ik0yLjgzMzE3IDE1TDEuNjY2NSAxMy44MzMzTDcuODMzMTcgNy42MjVMMTEuMTY2NSAxMC45NTgzTDE1LjQ5OTggNi42NjY2N0gxMy4zMzMyVjVIMTguMzMzMlYxMEgxNi42NjY1VjcuODMzMzNMMTEuMTY2NSAxMy4zMzMzTDcuODMzMTcgMTBMMi44MzMxNyAxNVoiIGZpbGw9IiMwNkNBM0QiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=";